// @ts-nocheck
import { Outlet, useLocation } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore'
import { useState, useCallback, useEffect } from 'react'
import { useTwilioDevice } from '../hooks/useTwilioDevice'
import { useWebSocket } from '../hooks/useWebSocket'
import { useQueuePolling } from '../hooks/useQueuePolling'
import { useWebSocketHandler } from '../hooks/useWebSocketHandler'
import { usePresenceManager } from '../hooks/usePresenceManager'
import { useOrganizationName } from '../hooks/useOrganizationName'
import { useWakeLockManager } from '../hooks/useWakeLockManager'
import { useCallDurationTimer } from '../hooks/useCallDurationTimer'
import { useCallStore } from '../stores/callStore'
import { logger } from '../utils/logger'
import CallStatusBar from './CallStatusBar'
import CustomerSidePanel from './CustomerSidePanel'
import InternalCallTransferPanel from './InternalCallTransferPanel'
import PendingTransferBanner from './PendingTransferBanner'
import ChatToggleButton from './ChatToggleButton'
import LayoutHeader from './LayoutHeader'
import LayoutSidebar from './LayoutSidebar'
import { ChatProvider } from '../contexts/ChatContext'

/**
 * アプリケーション全体のレイアウトコンポーネント
 * 責務を各カスタムフックとコンポーネントに委譲することで簡素化
 */
export default function Layout() {
  // Zustand Selector最適化: 必要な値のみを個別に取得
  const user = useAuthStore((state) => state.user)
  const logout = useAuthStore((state) => state.logout)
  const ringAudioEnabled = useCallStore((state) => state.ringAudioEnabled)
  const [sidebarOpen, setSidebarOpen] = useState(true)
  const location = useLocation()
  const isLineChatPage = location.pathname === '/line-chat'

  // 通話終了時のコールバック
  const handleCallEnd = useCallback(() => {
    logger.info('通話終了 - Layout')
  }, [])

  // デスクトップ通知の許可をリクエスト（初回ログイン時）
  useEffect(() => {
    if ('Notification' in window && Notification.permission === 'default') {
      Notification.requestPermission()
    }
  }, [])

  // Twilio Device初期化（Singletonパターン）
  useTwilioDevice(handleCallEnd)

  // WebSocketメッセージハンドリング
  const handleWsMessage = useWebSocketHandler(user)
  const { connected: wsConnected } = useWebSocket(handleWsMessage, null)

  // キュー同期: WS接続時は30s、未接続時は5s（バックグラウンド60s）
  useQueuePolling(wsConnected)

  // Presence管理（オンライン状態、定期ping、受付可否同期）
  usePresenceManager(user, ringAudioEnabled)

  // 通話時間タイマー（グローバル管理）
  useCallDurationTimer()

  // 組織名取得
  const orgName = useOrganizationName(user)

  // Wake Lock管理（ページ可視性変更時）
  useWakeLockManager(ringAudioEnabled)

  return (
    <ChatProvider>
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
        {/* 保留警告帯（最上部固定） */}
        
        {/* グローバル通話状態バー */}
        <CallStatusBar />
        
        {/* サイドバー */}
        <LayoutSidebar
          sidebarOpen={sidebarOpen}
          user={user}
          logout={logout}
        />

        {/* メインコンテンツエリア */}
        <div className={`transition-all duration-200 ${sidebarOpen ? 'ml-64' : 'ml-0'}`}>
          {/* ヘッダー */}
          <LayoutHeader
            sidebarOpen={sidebarOpen}
            setSidebarOpen={setSidebarOpen}
            orgName={orgName}
          />

          {/* コンテンツエリア */}
          <main className="min-h-[calc(100vh-73px)]">
            <div className="container mx-auto px-6 py-8">
              <Outlet />
            </div>
          </main>
        </div>

        {/* 通話中の顧客情報サイドパネル */}
        <CustomerSidePanel />
        
        {/* 内線通話中の転送パネル */}
        <InternalCallTransferPanel />

        {/* 転送割り当てバナー（転送先オペレータ用） */}
        <PendingTransferBanner />
        
        {/* チャット機能（LINEチャットページでは非表示） */}
        {!isLineChatPage && <ChatToggleButton />}
      </div>
    </ChatProvider>
  )
}
